import React from 'react';
import { useLocation } from 'react-router-dom';
import ErrorPage from './pages/error';

class ErrorBoundaryInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.location?.pathname !== prevProps.location?.pathname &&
            this.state.hasError
        ) {
            this.setState({ hasError: false, error: null });
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <ErrorPage
                    message={this.state.error?.message}
                    onReset={() => this.setState({ hasError: false, error: null })}
                />
            );
        }
        return this.props.children;
    }
}

export default function ErrorBoundary(props) {
    const location = useLocation();
    return <ErrorBoundaryInner {...props} location={location} />;
}
